import { ribbonExperiments, platformFeatures } from 'owa-acui';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

// Each `feature` is defined in
// https://office.visualstudio.com/Office/_git/1JS?path=/ooui/packages/acui-experiments/src/ribbonExperiments.ts

export const getRibbonExperiments = (feature: string): boolean =>
    baseFeatures.has(feature) ||
    (isGlobalFeatureEnabled('mon-ribbon-fluent-v9-ribbon') && getV9Features().has(feature)) ||
    (isGlobalFeatureEnabled('fwk-cache-ribbon') &&
        feature === ribbonExperiments.ribbonCachedScalingIsEnabled);

const baseFeatures = new Set([
    ribbonExperiments.multilineRibbonIsEnabled,
    ribbonExperiments.react18RenderDialogEnabled,
]);

const getV9Features = (): Set<string> => {
    const v9Features = new Set([
        ribbonExperiments.fluentV9RibbonControlsIsEnabled,
        ribbonExperiments.fluentV9TabListSpinButtonFocusIsEnabled,
    ]);

    if (isGlobalFeatureEnabled('mon-ribbon-fluent-v9-menus')) {
        v9Features.add(ribbonExperiments.fluentV9MenuIsEnabled);
    }
    return v9Features;
};

export const getPlatformExperiments = (feature: string): boolean =>
    isGlobalFeatureEnabled('fwk-cache-ribbon') &&
    feature === platformFeatures.cachedScalingUpAllowed;
